<template>
    <div>
        <el-card :key="index" v-for="(painspot, index) in painspot_list" style="margin-top:20px;text-align:left;margin-left:50px;width:800px;" shadow="hover">
            <div style="width:800px;">
                <div style="float:left;width:660px;" @click="show_article_details(painspot)" class="card_css">
                    <!-- <p>文章所在目录</p> -->
                    <p style="font-weight:bold;font-size:22px;">{{ painspot.title }}</p>
                    <p><span>问题背景：</span>
                        <span v-if="painspot.background.length>30">{{ painspot.background.substring(0, 30) }}...</span>
                        <span v-else>{{ painspot.background }}</span>
                    </p>
                    <p><span>现象描述：</span>
                        <span v-if="painspot.phenomenon.length>30">{{ painspot.phenomenon.substring(0, 30) }}...</span>
                        <span v-else>{{ painspot.phenomenon }}</span>
                    </p>
                    <p>提问时间：{{ painspot.create_time }}</p>
                </div>
                <div style="float:left;width:120px;text-align:center;margin-top:70px;">
                    <span v-if="painspot.status=='已发布'"><i class="el-icon-success" style="color:#67C23A;" /><span style="margin-left:5px;">已解决</span></span>
                    <div style="margin-top:5px;" v-if="painspot.status=='已发布'"><el-button type="primary" size="mini" @click="view_question_result(painspot.id)">查看结果</el-button></div>
                    <span v-if="painspot.status=='待处理'"><i class="el-icon-warning" style="color:#E6A23C;" /><span style="margin-left:5px;">待处理</span></span>
                    <span v-if="painspot.status=='已拒绝'"><i class="el-icon-error" style="color:#F56C6C" /><span style="margin-left:5px;">已驳回</span></span>
                    <div style="margin-top:5px;" v-if="painspot.status=='已拒绝'"><el-button type="primary" size="mini" @click="show_reason(painspot.reject_reason)">查看原因</el-button></div>
                </div>
            </div>
        </el-card>
        <el-dialog
          :visible.sync="dialogVisible"
          :fullscreen="true"
          :show-close="false"
          custom-class="fullscreen-dialog"
          @opened="handleDialogOpened"
          :close-on-click-modal="false"
          :close-on-press-escape="false">
          <template #title>
            <div class="dialog-header">
              <span style="font-size:25px;">我的提问</span>
              <el-button
                class="close-btn"
                icon="el-icon-close"
                @click="dialogVisible = false"
              ></el-button>
            </div>
          </template>

          <div class="dialog-content">
            <div style="text-align:left;">
              <el-form :model="form" label-width="120px" label-position="left" style="width:100%;margin-top:50px;" class="ql-editor">
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>问题标题</span>
                      </template>
                      <!-- <el-input v-model="form.title" placeholder="简明扼要地概括问题（如：关键人才离职率高怎么办？）"></el-input> -->
                      <el-autocomplete
                      v-model="form.title"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="简明扼要地概括问题（如：关键人才离职率高怎么办？）"
                      @select="viewRelatedTitle"
                      style="width:100%;"
                      disabled>
                      </el-autocomplete>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>问题背景</span>
                      </template>
                      <el-input v-model="form.background" type="textarea" autosize placeholder="描述问题发生的背景（如：公司发展阶段、行业特点、团队规模等）" disabled></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>现象描述</span>
                      </template>
                      <el-input v-model="form.phenomenon" type="textarea" autosize placeholder="详细描述问题的具体表现（如：过去半年内核心团队离职率达到30%）" disabled></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>可能导致的后果</span>
                      </template>
                      <el-input v-model="form.result" type="textarea" autosize placeholder="说明问题可能带来的负面影响（如：项目延期、团队士气低落）" disabled></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>可能的原因</span>
                      </template>
                      <el-input v-model="form.reason" type="textarea" autosize placeholder="列出你认为可能导致问题的原因（如：薪酬竞争力不足、缺乏职业发展路径）" disabled></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>解决目标</span>
                      </template>
                      <el-input v-model="form.target" type="textarea" autosize placeholder="你希望通过解决这个问题达到的具体目标（如：将离职率降低到10%以下）" disabled></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>已经采取的措施</span>
                      </template>
                      <el-input v-model="form.measure" type="textarea" autosize placeholder="已经采取的措施（如：提高了薪酬水平，但效果不明显）" disabled></el-input>
                  </el-form-item>
                  <el-divider>以下为可选部分</el-divider>
                  <el-form-item label="企业规模">
                      <el-input v-model="form.scale" placeholder="示例：200人，年营业额1亿" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="行业类型">
                      <el-input v-model="form.industry_type" placeholder="示例：科技" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="发展阶段">
                      <el-input v-model="form.develop_stage" placeholder="示例：成长期" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="问题发生的时间">
                      <el-input v-model="form.occur_time" placeholder="示例：从2023年1月开始，持续至今" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="问题发生的部门">
                      <el-input v-model="form.occur_department" placeholder="示例：技术研发部" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="问题影响的范围">
                      <el-input v-model="form.impact_scope" placeholder="示例：影响3个核心项目的进度" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="频率和强度">
                      <el-input v-model="form.frequency" placeholder="示例：每月发生一次，影响较大" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="相关数据支持">
                      <el-input v-model="form.supporting_data" type="textarea" autosize placeholder="附上员工满意度调查报告" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="期望的解决方案">
                      <el-input v-model="form.expect_solution" placeholder="示例：希望从薪酬和职业发展两方面入手" disabled></el-input>
                  </el-form-item>
              </el-form>
            </div> 
          </div>
        </el-dialog>
        <div style="width:100%;text-align:center;padding-top:20%;" v-if="painspot_list.length==0">
            <span style="font-size:22px;color:#F56C6C;font-weight:500;">提问列表为空！</span>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
  created() {
    this.getUserQuestions();
  },
  data() {
    return {
        // painspot_list: [
        // {'title': 'title1', 'desc': 'desc1', 'update_time': '2025/04/26 18:41:00', 'rank': '4.3/5', 'status': '已解决'}, 
        // {'title': 'title2', 'desc': 'desc2', 'update_time': '2025/04/25 15:31:00', 'rank': '4.9/5', 'status': '待解决'},
        // {'title': 'title3', 'desc': 'desc3', 'update_time': '2025/04/27 12:35:00', 'rank': '4.5/5', 'status': '已驳回'},],
        painspot_list: [],
        dialogVisible: false,
        form: {},
    }
  },
  methods: {
    view_question_result(id) {
        let params;
        params = {
            pid: id,
        }
        getdata.getListP("getResultTitle", params)
        .then(resp => {
            if(resp.data.code == 200){
                let result_title = resp.data.data;
                let routeData = this.$router.resolve({
                  path: '/glyf/main',
                  query: {title: result_title}
                });
                window.open(routeData.href, '_blank');            
            }else{
                this.$message({
                message: resp.data.message,
                type: "error",
                duration: 6000,
                })
            }
        })
        .catch(err => {
            console.log(err);
        });  
    },
    show_reason(reason) {
        this.$alert(reason, '原因', {
        confirmButtonText: '知道了',
        });
    },
    getUserQuestions() {
        getdata.getList("getUserQuestions")
        .then(resp => {
            if(resp.data.code == 200){
                this.painspot_list = resp.data.data;            
            }else{
                this.$message({
                message: resp.data.message,
                type: "error",
                duration: 6000,
                })
            }
        })
        .catch(err => {
            console.log(err);
        });  
    },
    show_article_details(question) {
        this.form = question; 
        this.dialogVisible = true;           
    },
  }
}
</script>

<style scoped>
.card_css:hover {
  cursor: pointer;
}
/* 【重要！】ql-editor 自带overflow，通过调整这里的height去自适应页面高度 */
.ql-editor {
  height: calc(100vh - 80px - 200px) !important;
}
::v-deep .editor-container .ql-editor {
  height: calc(100vh - 80px - 300px) !important;
}
::v-deep .el-form-item {
  margin-bottom: 5px;
}
::v-deep .el-input__inner {
  height: 33px;
}
</style>